<template>
  <div class="login_box">
    <div class="box_lift">
      <div class="lift_1">
        <img
          class="left_img"
          src="../../assets/img/left_logo.png"
          @dragstart.prevent
        />
        <div class="lift_2">{{ $t("main.text1") }}</div>
        <div class="lift_3">
          <div>{{ $t("main.text2") }}</div>
          <div>{{ $t("main.text3") }}</div>
        </div>
      </div>
    </div>
    <div class="box_right">
      <div class="r_box">
        <div
          v-loading="loadingQrcode"
          element-loading-background="rgb(237 246 252)"
        >
          <div class="ewm_box" ref="qrcode" @dragstart.prevent></div>
        </div>
        <div class="r_tit1">{{ $t("main.text4") }}</div>
        <div class="r_tit2">{{ $t("main.text5") }}</div>
        <!-- <button @click="go_home">进入首页</button> -->
      </div>
      <img
        class="btn_logo"
        src="../../assets/img/right_logo.png"
        @dragstart.prevent
      />
    </div>

    <el-dialog
      :visible.sync="loginDlgVisible"
      custom-class="login_dlg_style"
      :show-close="false"
      width="426px"
    >
      <div class="login_dlg_box">
        <i class="el-icon-circle-close icon_clo" @click="showQrcode"></i>
        <div class="u_img_box">
          <img
            class="u_img"
            src="../../assets/img/defalut_avatar.png"
            v-real-img="avatar"
          />
        </div>
        <div class="u_text" v-show="loginState == 2">
          {{ $t("main.text16") }}
        </div>
        <div class="u_text" v-show="loginState == 1">
          {{ $t("main.text17") }}
        </div>
        <div class="u_text u_text2" v-show="loginState == 1">
          {{ $t("main.text18") }}
        </div>
        <div class="text_btm" @click="showQrcode">
          {{ $t("main.text7") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import store from "@/store";
import QRCode from "qrcodejs2";
import router from "../../router";
import { checkLogin, getLoginUUID, getScan } from "@/api/api";
import { delay, toBase64 } from "@/utils/utils";
import { saveUserData } from "@/utils/userdata";
import { COMPLETE_FILE_URI } from "@/config/endpoints";

const qrcode = ref(null);
const loadingQrcode = ref(false);
const loginUUID = ref("");
let waitingScanTimerStart = false;
let waitingLoginTimerStart = false;
const username = ref("");
const avatar = ref("");
const loginState = ref(0);
const loginDlgVisible = computed({
  get: () => loginState.value > 0,
  set: () => showQrcode(),
});

function clearQrcodeInfo() {
  loginUUID.value = "";
  username.value = "";
  avatar.value = "";
}

async function showQrcode() {
  loginState.value = 0;
  loadingQrcode.value = true;
  for (let i = 0; i < 3; i++) {
    try {
      const res = await getLoginUUID();
      if (res && res.code === 200) {
        loginUUID.value = res.data.uuid;
        break;
      }
    } catch {}
    await delay(1000);
  }

  if (!loginUUID.value) return;

  const qrcodeData = toBase64(JSON.stringify({ id: loginUUID.value, type: 3 }));
  qrcode.value.innerHTML = "";
  new QRCode(qrcode.value, {
    width: 280,
    height: 280,
    text: qrcodeData,
    colorDark: "#000000",
    colorLight: "#ffffff",
    correctLevel: QRCode.CorrectLevel.H,
  });

  loadingQrcode.value = false;

  waitingScanTimerStart = true;
  getScanResult();
}

async function getScanResult() {
  await delay(2000);
  try {
    if (!waitingScanTimerStart) return;
    const res = await getScan(loginUUID.value);
    if (res && res.code === 200) {
      avatar.value = COMPLETE_FILE_URI(res.data.icon);
      waitingScanTimerStart = false;
      waitingLoginTimerStart = true;
      loginState.value = 1;
      return getLoginResult();
    } else if (res && res.code === 600) {
      waitingScanTimerStart = false;
      clearQrcodeInfo();
      return showQrcode();
    }
  } catch {}
  getScanResult();
}

async function getLoginResult() {
  await delay(2000);
  try {
    if (!waitingLoginTimerStart) return;
    const res = await checkLogin(loginUUID.value);
    if (res && res.code === 200) {
      if (res.data.icon) {
        res.data.icon = COMPLETE_FILE_URI(res.data.icon);
      }
      saveUserData(res.data);
      waitingLoginTimerStart = false;
      loginState.value = 2;
      await delay(1000);
      router.push({ name: "home" });
      return;
    } else if (res && res.code === 600) {
      waitingLoginTimerStart = false;
      clearQrcodeInfo();
      return showQrcode();
    }
  } catch {}
  getLoginResult();
}

onMounted(() => {
  if (store.state.user.authToken && store.state.user.userid) {
    return router.push({ name: "home" });
  }
  showQrcode();
});
</script>


<style scoped>
.login_box {
  width: 100%;
  height: 100vh;
  min-height: 800px;
  display: flex;
}
.box_lift {
  width: 45%;
  position: relative;
  background: url(../../assets/img/left_bgc.png) no-repeat;
  background-size: cover;
}
.box_right {
  width: 55%;
  background: url(../../assets/img/right_bgc.png) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.lift_1 {
  position: absolute;
  left: 13%;
  bottom: 18%;
  color: #fff;
}
.lift_2 {
  margin-bottom: 16px;
  font-size: 48px;
  font-weight: 500;
  line-height: 55px;
}
.lift_3 {
  word-wrap: break-word;
  word-break: break-word;
  font-size: 20px;
  font-weight: 500;
  line-height: 34px;
  max-width: 460px;
}
.left_img {
  max-width: 335px;
  margin-left: -33px;
}
.r_box {
  text-align: center;
}
.ewm_box {
  width: 280px;
  height: 280px;
  display: block;
  margin: auto;
}
.r_tit1 {
  font-size: 30px;
  font-weight: 500;
  color: #3b7bb9;
  margin: 20px 0 12px;
}
.r_tit2 {
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 31px;
}
.btn_logo {
  position: absolute;
  width: 132px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
}
.login_dlg_box {
  width: 426px;
  height: 584px;
  position: relative;
}
.icon_clo {
  color: #999999;
  cursor: pointer;
  position: absolute;
  left: 16px;
  top: 16px;
  font-size: 28px;
}
.u_img_box {
  padding-top: 120px;
}
.u_img {
  display: block;
  margin: auto;
  width: 150px;
  height: 150px;
  background: pink;
}
.u_text {
  text-align: center;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin-top: 16px;
}
.u_text2 {
  font-size: 18px;
  margin-top: 10px;
}
.text_btm {
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0079db;
  line-height: 33px;
  letter-spacing: 1px;
  text-align: center;
  position: absolute;
  bottom: 50px;
  width: 100%;
  cursor: pointer;
}
</style>

<style>
.login_dlg_style {
  margin-top: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

.login_dlg_style .el-dialog__body,
.login_dlg_style .el-dialog__header {
  padding: 0 !important;
}
</style>